var map = {
  "./index_tariffs": "799",
  "./index_tariffs.js": "799",
  "./index_tars": "27818",
  "./index_tars.js": "27818",
  "./omie": "2597",
  "./omie.js": "2597",
  "./omie_table": "40274",
  "./omie_table.js": "40274",
  "./save": "3038",
  "./save.js": "3038",
  "./show": "12450",
  "./show.js": "12450",
  "./tabs": "88979",
  "./tabs.js": "88979"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 52637;
